<svg width="100%" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.58579 6.5H1.41421C0.523309 6.5 0.0771428 5.42286 0.707108 4.79289L4.79289 0.707107C5.18342 0.316583 5.81658 0.316583 6.20711 0.707108L10.2929 4.79289C10.9229 5.42286 10.4767 6.5 9.58579 6.5Z" fill="#45586B"/>
</svg>
